import SearchableSelect from "./SearchableSelect";

// German country names with ISO 3166-1 alpha-2 code as value.
// DACH region first, then EU, then rest alphabetical.
const COUNTRIES = [
  { value: "AT", label: "Österreich" },
  { value: "DE", label: "Deutschland" },
  { value: "CH", label: "Schweiz" },
  { value: "LI", label: "Liechtenstein" },
  // EU
  { value: "BE", label: "Belgien" },
  { value: "BG", label: "Bulgarien" },
  { value: "HR", label: "Kroatien" },
  { value: "CY", label: "Zypern" },
  { value: "CZ", label: "Tschechien" },
  { value: "DK", label: "Dänemark" },
  { value: "EE", label: "Estland" },
  { value: "FI", label: "Finnland" },
  { value: "FR", label: "Frankreich" },
  { value: "GR", label: "Griechenland" },
  { value: "HU", label: "Ungarn" },
  { value: "IE", label: "Irland" },
  { value: "IT", label: "Italien" },
  { value: "LV", label: "Lettland" },
  { value: "LT", label: "Litauen" },
  { value: "LU", label: "Luxemburg" },
  { value: "MT", label: "Malta" },
  { value: "NL", label: "Niederlande" },
  { value: "PL", label: "Polen" },
  { value: "PT", label: "Portugal" },
  { value: "RO", label: "Rumänien" },
  { value: "SK", label: "Slowakei" },
  { value: "SI", label: "Slowenien" },
  { value: "ES", label: "Spanien" },
  { value: "SE", label: "Schweden" },
  // Adjacent / common transport
  { value: "BA", label: "Bosnien und Herzegowina" },
  { value: "GB", label: "Vereinigtes Königreich" },
  { value: "MK", label: "Nordmazedonien" },
  { value: "ME", label: "Montenegro" },
  { value: "NO", label: "Norwegen" },
  { value: "RS", label: "Serbien" },
  { value: "TR", label: "Türkei" },
  { value: "UA", label: "Ukraine" },
  // World
  { value: "AL", label: "Albanien" },
  { value: "AR", label: "Argentinien" },
  { value: "AU", label: "Australien" },
  { value: "BR", label: "Brasilien" },
  { value: "CA", label: "Kanada" },
  { value: "CN", label: "China" },
  { value: "EG", label: "Ägypten" },
  { value: "IN", label: "Indien" },
  { value: "IL", label: "Israel" },
  { value: "JP", label: "Japan" },
  { value: "MA", label: "Marokko" },
  { value: "MX", label: "Mexiko" },
  { value: "RU", label: "Russland" },
  { value: "SA", label: "Saudi-Arabien" },
  { value: "ZA", label: "Südafrika" },
  { value: "KR", label: "Südkorea" },
  { value: "TN", label: "Tunesien" },
  { value: "US", label: "Vereinigte Staaten" },
];

// Build options with ISO code as hint
const OPTIONS = COUNTRIES.map((c) => ({ value: c.value, label: c.label, hint: c.value }));

export const COUNTRIES_LIST = COUNTRIES;

export default function CountryPicker({
  value,
  onChange,
  placeholder = "— Land wählen —",
  testid = "country-picker",
  disabled = false,
}) {
  return (
    <SearchableSelect
      options={OPTIONS}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
      testid={testid}
      disabled={disabled}
      emptyText="Kein Land gefunden"
    />
  );
}
